/* eslint-disable import/prefer-default-export */
const FETCH_LOGS = 'app/log/FETCH_LOGS';
const SET_LOGS = 'app/log/SET_LOGS';

export { FETCH_LOGS, SET_LOGS };
